import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const CrossScopeAutoLoginPage = lazyWithRetry(() =>
  import("@/features/auth/pages/CrossScopeAutoLoginPage").then((m) => ({ default: m.CrossScopeAutoLoginPage })),
);
const ForgotPasswordPage = lazyWithRetry(() =>
  import("@/features/auth/pages/ForgotPasswordPage").then((m) => ({ default: m.ForgotPasswordPage })),
);
const ImpersonateGrantPage = lazyWithRetry(() =>
  import("@/features/auth/pages/ImpersonateGrantPage").then((m) => ({ default: m.ImpersonateGrantPage })),
);
const ImpersonatePage = lazyWithRetry(() =>
  import("@/features/auth/pages/ImpersonatePage").then((m) => ({ default: m.ImpersonatePage })),
);
const LoginPage = lazyWithRetry(() => import("@/features/auth/pages/LoginPage").then((m) => ({ default: m.LoginPage })));
const LogoutPage = lazyWithRetry(() =>
  import("@/features/auth/pages/LogoutPage").then((m) => ({ default: m.LogoutPage })),
);
const ResetPasswordPage = lazyWithRetry(() =>
  import("@/features/auth/pages/ResetPasswordPage").then((m) => ({ default: m.ResetPasswordPage })),
);

export const LOGIN_PATH = "/connexion";
export const LOGIN_ALIAS_PATH = "/login";
export const LOGOUT_PATH = "/deconnexion";
export const FORGOT_PASSWORD_PATH = "/mot-de-passe";
export const RESET_PASSWORD_PATH = "/reconfig";
export const IMPERSONATE_PATH = "/abracadabra";
export const IMPERSONATE_GRANT_PATH = "/impersonate-grant";
export const AUTO_LOGIN_PATH = "/auto-login";

const authRoutes: RouteConfig[] = [
  {
    path: LOGIN_PATH,
    element: <LoginPage />,
    isProtected: false,
    useMainLayout: false,
  },
  {
    path: LOGIN_ALIAS_PATH,
    element: <LoginPage />,
    isProtected: false,
    useMainLayout: false,
  },
  {
    path: IMPERSONATE_PATH,
    element: <ImpersonatePage />,
    isProtected: false,
    useMainLayout: false,
  },
  {
    path: IMPERSONATE_GRANT_PATH,
    element: <ImpersonateGrantPage />,
    isProtected: false,
    useMainLayout: false,
  },
  {
    path: AUTO_LOGIN_PATH,
    element: <CrossScopeAutoLoginPage />,
    isProtected: false,
    useMainLayout: false,
  },
  {
    path: LOGOUT_PATH,
    element: <LogoutPage />,
    isProtected: true,
    useMainLayout: false,
  },
  {
    path: FORGOT_PASSWORD_PATH,
    element: <ForgotPasswordPage />,
    isProtected: false,
    useMainLayout: false,
  },
  {
    path: RESET_PASSWORD_PATH,
    element: <ResetPasswordPage />,
    isProtected: false,
    useMainLayout: false,
  },
];

export default authRoutes;
